import { Component } from '@angular/core';


export class SkyFluidGridDemoComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-fluid-grid-demo',
  template: `<div class="highlight-columns">
  <sky-row>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="3">
      small="3"
    </sky-column>
    <sky-column screenSmall="3">
      small="3"
    </sky-column>
    <sky-column screenSmall="3">
      small="3"
    </sky-column>
    <sky-column screenSmall="3">
      small="3"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="4">
      small="4"
    </sky-column>
    <sky-column screenSmall="4">
      small="4"
    </sky-column>
    <sky-column screenSmall="4">
      small="4"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="5">
      small="5"
    </sky-column>
    <sky-column screenSmall="7">
      small="7"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="6">
      small="6"
    </sky-column>
    <sky-column screenSmall="6">
      small="6"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="8">
      small="8"
    </sky-column>
    <sky-column screenSmall="4">
      small="4"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="9">
      small="9"
    </sky-column>
    <sky-column screenSmall="3">
      small="3"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="10">
      small="10"
    </sky-column>
    <sky-column screenSmall="2">
      small="2"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenSmall="11">
      small="11"
    </sky-column>
    <sky-column screenSmall="1">
      small="1"
    </sky-column>
  </sky-row>

  <sky-row>
    <sky-column screenXSmall="6" screenSmall="8" screenMedium="9" screenLarge="10">
        screenXSmall="6" small="8" medium="9" large="10"
    </sky-column>
    <sky-column screenXSmall="6" screenSmall="4" screenMedium="3" screenLarge="2">
        screenXSmall="6" small="4" medium="3" large="2"
    </sky-column>
  </sky-row>

  <sky-row [reverseColumnOrder]="true">
    <sky-column screenSmall="4">
      First column
    </sky-column>
    <sky-column screenSmall="4">
      Second column
    </sky-column>
    <sky-column screenSmall="4">
      Third column
    </sky-column>
  </sky-row>
</div>
`,
  styles: [`
  .highlight-columns .sky-column {
    background-color: #97eced;
    border: 1px solid #56e0e1;
    overflow-wrap: break-word;
  }
  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
